import posthog from 'posthog-js';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (config.public.posthog.apiKey && config.public.posthog.apiHost) {
    const { user } = useOidcAuth();
    const posthogClient = posthog.init(config.public.posthog.apiKey, {
      api_host: config.public.posthog.apiHost,
      ui_host: config.public.posthog.uiHost,
      capture_pageview: false,
      capture_pageleave: true,
      capture_dead_clicks: true,
      loaded: () => {
        if (config.public.env === 'development') {
          posthog.debug();
        }
        const userSub = user.value?.userInfo?.sub as string;
        const orgId = user.value?.userInfo?.org_id as string;
        const userId = orgId ? `${orgId}-${userSub}` : userSub;
        if (userId) {
          posthog.identify(userId, {
            email: user.value?.userInfo?.email,
            name: user.value?.userInfo?.name,
            namespaceId: user.value?.userInfo?.namespaceId,
            orgId: user.value?.userInfo?.org_id,
          });
        }
      },
    });

    // Make sure that pageviews are captured with each route change
    const router = useRouter();
    router.afterEach((to) => {
      nextTick(() => {
        posthog.capture('$pageview', {
          current_url: to.fullPath,
        });
      });
    });

    return {
      provide: {
        posthog: posthogClient,
      },
    };
  }
});
